import { IDropdownOption } from "office-ui-fabric-react";
import { DecodeRegionalPartnership, DecodeSchoolType, getLocalAuthorityList, getRegionalPartnershipList, getSchoolList, WsDecodeLocalAuthority, WsDecodeSchool } from "./decode-data-hwb";
import { randomInRange } from "./decode-number-helpers";







interface DecodeDateRange {
  start: Date | null;
  end: Date | null;
}








// const regionalPartnershipList: DecodeRegionalPartnership[] = getRegionalPartnershipList();

const regionalPartnershipList: DecodeRegionalPartnership[] = [

  { id: 'ams',                   name: 'Zone Americas (AMS)'   },
  { id: 'eur',                   name: 'Zone Europe (EUR)'   },
  { id: 'aoa',                   name: 'Zone Asia, Oceania & Africa (AOA)'   },

  // { id: 'csc',                   name: 'CSC'   },
  // { id: 'eas',                   name: 'EAS'   },
  // { id: 'gwe',                   name: 'GwE'   },
  // { id: 'mid_wales_partnership', name: 'Mid Wales Partnership'   },
  // { id: 'neath_port_talbot',     name: 'Neath Port Talbot'   },
  // { id: 'y_partneriaeth',        name: 'Y Partneriaeth'   },
];






const localAuthorityList: WsDecodeLocalAuthority[] = getLocalAuthorityList();

// [
//   { id: '001', name: 'Blaenau Gwent'     },
//   { id: '002', name: 'Bridgend'          },
//   { id: '003', name: 'Caerphilly'        },
//   { id: '004', name: 'Cardiff'           },
//   { id: '005', name: 'Carmarthenshire'   },
//   { id: '006', name: 'Ceredigion'        },
//   { id: '007', name: 'Conwy'             },
//   { id: '008', name: 'Denbighshire'      },
//   { id: '009', name: 'Flintshire'        },
//   { id: '010', name: 'Gwynedd'           },
//   { id: '011', name: 'Isle of Anglesey'  },
//   { id: '012', name: 'Merthyr Tydfil'    },
//   { id: '013', name: 'Monmouthshire'     },
//   { id: '014', name: 'Neath Port Talbot' },
//   { id: '015', name: 'Newport'           },
//   { id: '016', name: 'Pembrokeshire'     },
//   { id: '017', name: 'Powys'             },
//   { id: '018', name: 'Rhondda Cynon Taf' },
//   { id: '019', name: 'Swansea'           },
//   { id: '020', name: 'Torfaen'           },
//   { id: '021', name: 'Vale of Glamorgan' },
//   { id: '022', name: 'Wrexham'           },
// ];










const schoolTypeList: DecodeSchoolType[] = [

  { id: '1',   name: 'Nespresso'   },
  { id: '2',   name: 'NHs (Nestlé Health Science)'   },
  { id: '3',   name: 'Nestlé Waters'   },

  // { id: 'primary',   name: 'Primary Schools'   },
  // { id: 'middle',    name: 'Middle Schools'    },
  // { id: 'secondary', name: 'Secondary Schools' },
  // { id: 'college',   name: 'Colleges'          },
  // { id: 'aln',       name: 'ALN Schools'       },
];





const schoolList: WsDecodeSchool[] = getSchoolList();

// [

//   { id: '001001', regionalPartnershipId: '', localAuthorityId: '001', name: 'Blaenycwm Primary School' },
//   { id: '001002', regionalPartnershipId: '', localAuthorityId: '001', name: 'Willowtown Primary School' },

//   { id: '002001', regionalPartnershipId: '', localAuthorityId: '002', name: 'Brynteg School' },
//   { id: '002002', regionalPartnershipId: '', localAuthorityId: '002', name: 'Corneli Primary School' },

//   { id: '003001', regionalPartnershipId: '', localAuthorityId: '003', name: 'Ysgol Gyfun Cwm Rhymni' },

//   { id: '004001', regionalPartnershipId: '', localAuthorityId: '004', name: 'Cardiff High School' },
//   { id: '004002', regionalPartnershipId: '', localAuthorityId: '004', name: 'Cardiff Sixth Form College' },
//   { id: '004003', regionalPartnershipId: '', localAuthorityId: '004', name: 'Cardiff West Community High School' },
//   { id: '004004', regionalPartnershipId: '', localAuthorityId: '004', name: 'Eglwys Wen Primary School' },
//   { id: '004005', regionalPartnershipId: '', localAuthorityId: '004', name: 'Llanedeyrn High School' },
//   { id: '004006', regionalPartnershipId: '', localAuthorityId: '004', name: 'Michaelston Community College' },
//   { id: '004007', regionalPartnershipId: '', localAuthorityId: '004', name: `St Cadoc's Primary School` },

//   { id: '005001', regionalPartnershipId: '', localAuthorityId: '005', name: `Queen Elizabeth High School `},

// ];






const getRegionalPartnershipOptions = () => {
  const options: IDropdownOption[] = [];

  options.push({ key: '', text: 'All' });

  regionalPartnershipList.forEach((item) => {
    options.push({ key: item.id, text: `${item.name}` });
  });

  return options;
};




const getLocalAuthorityOptions = (selectedRegionalPartnershipId: string | undefined) => {
  const options: IDropdownOption[] = [];

  options.push({ key: '', text: 'All' });

  localAuthorityList
  .filter((item) => {

    let filter = true;

    if (selectedRegionalPartnershipId) {
      // if (item.regionalPartnershipId !== selectedRegionalPartnershipId) {
      //   filter = false;
      // }

      const schools = item.schools.filter((s) => s.regionalPartnershipId === selectedRegionalPartnershipId);
      if (schools.length === 0) {
        filter = false;
      }
    }

    return filter;

  })
  .forEach((item) => {
    options.push({ key: item.id, text: `${item.name} (${item.id})` });
  });

  return options;
};





const getSchoolTypeOptions = () => {
  const options: IDropdownOption[] = [];

  options.push({ key: '', text: 'All' });

  schoolTypeList.forEach((item) => {
    options.push({ key: item.id, text: `${item.name}` });
  });

  return options;
};







const getSchoolOptions = (selectedRegionalPartnershipId: string | undefined, selectedLocalAuthorityId: string | undefined) => {
  const options: IDropdownOption[] = [];

  options.push({ key: '', text: 'All' });

  schoolList
    .filter((item) => {

      let filter = true;

      if (selectedRegionalPartnershipId) {
        if (item.regionalPartnershipId !== selectedRegionalPartnershipId) {
          filter = false;
        }
      }

      if (selectedLocalAuthorityId) {
        if (item.localAuthorityId !== selectedLocalAuthorityId) {
          filter = false;
        }
      }

      return filter;

    })
    .forEach((item) => {
      options.push({ key: item.id, text: `${item.name} (${item.id})` });
    });

  return options;
};




// const adjustmentFactors: { [ key: string ]: number[] } = {

//   '001001': [ 0.75, 0.30, 0.40, 0.30, 0.88, 0.40 ],
//   '001002': [ 0.80 ],

//   '002001': [ 0.70, 0.60, 0.20, 0.90, 0.50, 0.95 ],
//   '002002': [ 0.85 ],

//   '003001': [ 0.90, 0.40, 0.50, 0.60, 0.50, 0.70 ],

//   '004001': [ 0.50, 0.40, 0.77, 0.71, 0.90, 0.50 ],
//   '004002': [ 0.80, 0.50, 0.20, 0.35, 0.55, 0.71 ],
//   '004003': [ 0.70, 0.20, 0.90, 0.88, 0.33, 0.90 ],
//   '004004': [ 0.60 ],
//   '004005': [ 0.75 ],
//   '004006': [ 0.85 ],
//   '004007': [ 0.90 ],

//   '005001': [ 0.80, 0.60, 0.95, 0.44, 0.33, 0.70 ]

// };

























const getAdjustmentFactor = (filterId: string, index: number): number =>{

  // const value = adjustmentFactors[filterId];

  const v1 = randomInRange(`${filterId}-1`, 0.50, 0.95, 0.05);
  const v2 = randomInRange(`${filterId}-1`, 0.50, 0.95, 0.05);
  const v3 = randomInRange(`${filterId}-1`, 0.50, 0.95, 0.05);
  const v4 = randomInRange(`${filterId}-1`, 0.50, 0.95, 0.05);
  const v5 = randomInRange(`${filterId}-1`, 0.50, 0.95, 0.05);
  const v6 = randomInRange(`${filterId}-1`, 0.50, 0.95, 0.05);

  const value = [ v1, v2, v3, v4, v5, v6 ];

  if (value) {

    if (index > 0 && value[index]) {
      return value[index];
    } else {
      return value[0];
    }

  } else {
    return 1;
  }
};





















export {

  getRegionalPartnershipOptions,

  getLocalAuthorityOptions,

  getSchoolTypeOptions,
  getSchoolOptions,
  getAdjustmentFactor
};




export type {
  DecodeDateRange
};
